import { isAuthenticated } from "@store/action/auth";
import { getUser, updateUserOnLocal } from "@store/action/user";
import { useState, useEffect, useMemo, useCallback } from "react";
import { getCouriers } from "@store/action/courier";

export default function useProfile() {
  /** @type {[import("@store/action/user").User, function]} */
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  /** 
   * Courier code to name map
   * @type {[Map<string, string>, function]} 
   * */
  const [courierMap, setCourierMap] = useState(new Map());

  const fetchUser = useCallback(async () => {
    try {
      const { user, token } = isAuthenticated();
      if (user?.courier) {
        setUser(user);
        setLoading(false);
        return;
      }
      
      const result = await getUser(token);
      if (result.success) {
        updateUserOnLocal(result.data, () => {});
        setUser(result.data);
      } else {
        alert("Gagal mengambil data akun, silahkan refresh halaman");
      }
    } catch (error) {
      alert("Terjadi kesalahan saat mengambil data");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCouriers = useCallback(async () => {
    const result = await getCouriers();
    if (result.success) {
      const uniqueCouriers = result.couriers.reduce((acc, courier) => {
        acc.set(courier.courierCode, courier.courierName);
        return acc;
      }, new Map());
      setCourierMap(uniqueCouriers);
    }
  }, []);

  useEffect(() => {
    fetchUser();
    fetchCouriers();
  }, [fetchUser, fetchCouriers]);

  const courierName = useMemo(() => {
    if (user?.courier?.openCourierName) return user?.courier?.openCourierName;
    if (user?.courier?.courierCode) return courierMap.get(user?.courier?.courierCode);
    return "Not Found";
  }, [user, courierMap]);

  const courierType = useMemo(() => {
    if (user?.courier?.courierType) return user?.courier?.courierType.charAt(0).toUpperCase() + user?.courier?.courierType.slice(1);
    return "Not Found";
  }, [user]);

  return { user, loading, courierName, courierType };
}
